import { ServiceProvider } from "./service.provider";
import { BaseService } from "./base.service";

export class SchedulerBaseService extends BaseService {
  constructor(public endpoint: string, public provider: ServiceProvider) {
    super(endpoint, provider);
  }
}
